/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.bundle.v2
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.bundle = {};
proto.witbooking.backoffice.bundle.v2 = require('./bundle_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.bundle.v2.CreateBundleRequest,
 *   !proto.witbooking.backoffice.bundle.v2.CreateBundleResponse>}
 */
const methodDescriptor_BundleAPI_CreateBundle = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.bundle.v2.BundleAPI/CreateBundle',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.bundle.v2.CreateBundleRequest,
  proto.witbooking.backoffice.bundle.v2.CreateBundleResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v2.CreateBundleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.bundle.v2.CreateBundleRequest,
 *   !proto.witbooking.backoffice.bundle.v2.CreateBundleResponse>}
 */
const methodInfo_BundleAPI_CreateBundle = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.bundle.v2.CreateBundleResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v2.CreateBundleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.CreateBundleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.bundle.v2.CreateBundleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.bundle.v2.CreateBundleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIClient.prototype.createBundle =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v2.BundleAPI/CreateBundle',
      request,
      metadata || {},
      methodDescriptor_BundleAPI_CreateBundle,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.CreateBundleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.bundle.v2.CreateBundleResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIPromiseClient.prototype.createBundle =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v2.BundleAPI/CreateBundle',
      request,
      metadata || {},
      methodDescriptor_BundleAPI_CreateBundle);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest,
 *   !proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse>}
 */
const methodDescriptor_BundleAPI_UpdateBundle = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.bundle.v2.BundleAPI/UpdateBundle',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest,
  proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest,
 *   !proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse>}
 */
const methodInfo_BundleAPI_UpdateBundle = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIClient.prototype.updateBundle =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v2.BundleAPI/UpdateBundle',
      request,
      metadata || {},
      methodDescriptor_BundleAPI_UpdateBundle,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIPromiseClient.prototype.updateBundle =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v2.BundleAPI/UpdateBundle',
      request,
      metadata || {},
      methodDescriptor_BundleAPI_UpdateBundle);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest,
 *   !proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse>}
 */
const methodDescriptor_BundleAPI_DeleteBundle = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.bundle.v2.BundleAPI/DeleteBundle',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest,
  proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest,
 *   !proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse>}
 */
const methodInfo_BundleAPI_DeleteBundle = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIClient.prototype.deleteBundle =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v2.BundleAPI/DeleteBundle',
      request,
      metadata || {},
      methodDescriptor_BundleAPI_DeleteBundle,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIPromiseClient.prototype.deleteBundle =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v2.BundleAPI/DeleteBundle',
      request,
      metadata || {},
      methodDescriptor_BundleAPI_DeleteBundle);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.bundle.v2.GetBundleRequest,
 *   !proto.witbooking.backoffice.bundle.v2.GetBundleResponse>}
 */
const methodDescriptor_BundleAPI_GetBundle = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.bundle.v2.BundleAPI/GetBundle',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.bundle.v2.GetBundleRequest,
  proto.witbooking.backoffice.bundle.v2.GetBundleResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v2.GetBundleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v2.GetBundleResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.bundle.v2.GetBundleRequest,
 *   !proto.witbooking.backoffice.bundle.v2.GetBundleResponse>}
 */
const methodInfo_BundleAPI_GetBundle = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.bundle.v2.GetBundleResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v2.GetBundleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v2.GetBundleResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.bundle.v2.GetBundleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.bundle.v2.GetBundleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIClient.prototype.getBundle =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v2.BundleAPI/GetBundle',
      request,
      metadata || {},
      methodDescriptor_BundleAPI_GetBundle,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.bundle.v2.GetBundleResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIPromiseClient.prototype.getBundle =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v2.BundleAPI/GetBundle',
      request,
      metadata || {},
      methodDescriptor_BundleAPI_GetBundle);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.bundle.v2.GetBundlesRequest,
 *   !proto.witbooking.backoffice.bundle.v2.GetBundlesResponse>}
 */
const methodDescriptor_BundleAPI_GetBundles = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.bundle.v2.BundleAPI/GetBundles',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.bundle.v2.GetBundlesRequest,
  proto.witbooking.backoffice.bundle.v2.GetBundlesResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v2.GetBundlesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.bundle.v2.GetBundlesRequest,
 *   !proto.witbooking.backoffice.bundle.v2.GetBundlesResponse>}
 */
const methodInfo_BundleAPI_GetBundles = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.bundle.v2.GetBundlesResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v2.GetBundlesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundlesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.bundle.v2.GetBundlesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.bundle.v2.GetBundlesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIClient.prototype.getBundles =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v2.BundleAPI/GetBundles',
      request,
      metadata || {},
      methodDescriptor_BundleAPI_GetBundles,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundlesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.bundle.v2.GetBundlesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIPromiseClient.prototype.getBundles =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v2.BundleAPI/GetBundles',
      request,
      metadata || {},
      methodDescriptor_BundleAPI_GetBundles);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest,
 *   !proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse>}
 */
const methodDescriptor_BundleAPI_ReorderBundle = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.bundle.v2.BundleAPI/ReorderBundle',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest,
  proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest,
 *   !proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse>}
 */
const methodInfo_BundleAPI_ReorderBundle = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIClient.prototype.reorderBundle =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v2.BundleAPI/ReorderBundle',
      request,
      metadata || {},
      methodDescriptor_BundleAPI_ReorderBundle,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.bundle.v2.BundleAPIPromiseClient.prototype.reorderBundle =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v2.BundleAPI/ReorderBundle',
      request,
      metadata || {},
      methodDescriptor_BundleAPI_ReorderBundle);
};


module.exports = proto.witbooking.backoffice.bundle.v2;

